import { Directive, OnDestroy, OnInit, inject, output } from '@angular/core';
import {Subscription} from 'rxjs';
import {ColumnSortedEvent, SortService} from '../services/sort-service';

@Directive({
  selector: '[sortable-table]',
  standalone: true
})
export class SortableTableDirective implements OnInit, OnDestroy {
  private readonly sortService = inject(SortService);


  readonly sorted = output<ColumnSortedEvent>();

  private columnSortedSubscription!: Subscription;

  ngOnInit() {
    this.columnSortedSubscription = this.sortService.columnSorted$.subscribe(event => {
      this.sorted.emit(event);
    });
  }

  ngOnDestroy() {
    this.columnSortedSubscription.unsubscribe();
  }

}
